module.exports = __webpack_public_path__ + "img/logo_delegate_cash.33e11877.svg";